import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import { cn } from "../../lib/utils";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";
import { Calendar } from "./calendar";
export function DatePicker({ value, onChange, placeholder = "Pick a date", className }) {
    const [date, setDate] = React.useState(value ? new Date(value) : undefined);
    React.useEffect(() => {
        if (value) {
            setDate(new Date(value));
        }
        else {
            setDate(undefined);
        }
    }, [value]);
    const handleSelect = (newDate) => {
        setDate(newDate);
        if (newDate) {
            onChange?.(format(newDate, "yyyy-MM-dd"));
        }
    };
    return (_jsxs(Popover, { children: [_jsx(PopoverTrigger, { asChild: true, children: _jsxs("button", { type: "button", className: cn("relative flex w-full items-center rounded-xl border border-light-border dark:border-dark-border", "bg-light-elevated dark:bg-dark-elevated", "h-9 min-h-[36px] pl-9 pr-3 py-1.5", "text-xs text-light-text dark:text-dark-text", "shadow-sm transition-colors text-left font-normal", "hover:bg-light-elevated dark:hover:bg-dark-elevated", "focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:border-purple-500", !date && "text-light-text-muted dark:text-dark-text-muted", className), children: [_jsx(CalendarIcon, { className: "absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-light-text-muted dark:text-dark-text-muted pointer-events-none" }), date ? format(date, "dd MMM yyyy") : _jsx("span", { children: placeholder })] }) }), _jsx(PopoverContent, { className: "w-auto p-0", align: "start", children: _jsx(Calendar, { mode: "single", selected: date, onSelect: handleSelect, captionLayout: "dropdown", initialFocus: true }) })] }));
}
